import { render, staticRenderFns } from "./SACCheckbox.vue?vue&type=template&id=1213ace9"
import script from "./SACCheckbox.vue?vue&type=script&lang=js"
export * from "./SACCheckbox.vue?vue&type=script&lang=js"
import style0 from "./SACCheckbox.vue?vue&type=style&index=0&id=1213ace9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports